import React from "react"
import classnames from "classnames"
import _map from "lodash/map"

import styles from "./styles.css"

const Table = () => {
  const itemClasses = classnames(styles.itemTable, styles.skeleton)
  const containerLine = classnames(
    styles.containerItem,
    "u-flex u-flexJustifyBetween"
  )
  return (
    <div className={styles.table}>
      {_map(Array(6), () => {
        return (
          <div className={containerLine}>
            <div className={itemClasses}></div>
            <div className={itemClasses}></div>
            <div className={itemClasses}></div>
            <div className={itemClasses}></div>
          </div>
        )
      })}
    </div>
  )
}

export default Table



// WEBPACK FOOTER //
// ./src/components/Skeleton/IncidentManagerSkeleton/Table.js